module.exports = __webpack_public_path__ + "img/STJsepia.43875b68.png";